import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetWorkspacesQuery = () => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["workspaces"],
    queryFn: async () => {
      // try {
      const { data, status } = await authApi.get<Array<Workspace>>(
        `/workspace`
      );
      return { data, status };
    },
  });

  return result;
};
